export default "__VITE_ASSET__Bem_G4YK__"